module.exports = __webpack_public_path__ + "static/media/11.868046f5.jpg";